import { createSelector } from 'reselect'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectWelcomeFlowPartners = createSelector(
  [selectWelcomeFlowState],
  (state) => state.Partners
)
